import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactionsinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "M3.375 6.75H.75m2.625 4.5H2.25M3.375 9H1.5m1.125 4.611A3.74 3.74 0 0 0 6 15.75h6A3.75 3.75 0 0 0 15.75 12V6A3.75 3.75 0 0 0 12 2.25H6a3.74 3.74 0 0 0-3.375 2.139M9 5.625v.75m0 6v-.75"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.15,
		d: "M7.394 10.687c.296.609.93.979 1.606.938a1.536 1.536 0 0 0 1.688-1.313v0c0-.567-.4-1.055-.957-1.166L8.27 8.854a1.19 1.19 0 0 1-.957-1.167v0A1.536 1.536 0 0 1 9 6.375a1.67 1.67 0 0 1 1.606.937"
	})]
});
export default SvgTransactionsinline;
